import React from "react";
import {
  AlertCircle,
  CalendarX,
  Ban,
  CheckCircle,
  Clock,
  CreditCard,
  PhoneCall,
  RotateCw,
  Send,
} from "lucide-react";
import { EventStatusEnum } from "./eventStatus";

export const statusIcons: Record<EventStatusEnum, React.ReactNode> = {
  [EventStatusEnum.NEW]: <AlertCircle className="h-4 w-4" />,
  [EventStatusEnum.CONTACTED]: <PhoneCall className="h-4 w-4" />,
  [EventStatusEnum.BIDSENT]: <Send className="h-4 w-4" />,
  [EventStatusEnum.AWAITINGPAYMENT]: <CreditCard className="h-4 w-4" />,
  [EventStatusEnum.EXPIRED]: <Clock className="h-4 w-4" />,
  [EventStatusEnum.FOLLOWEDUP]: <RotateCw className="h-4 w-4" />,
  [EventStatusEnum.COMPLETE]: <CheckCircle className="h-4 w-4" />,
  [EventStatusEnum.CANCELLED]: <Ban className="h-4 w-4" />,
  [EventStatusEnum.DATE_FULL]: <CalendarX className="h-4 w-4" />,
};
